export default __webpack_public_path__ + "media/images/logo-48cded937af3c39a2fa5697eb22041b2.png";